import { createClient, type ClientConfig } from '@sanity/client';

const projectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID ?? 'jx97fmzi';
const dataset = process.env.NEXT_PUBLIC_SANITY_DATASET ?? 'eo';
const apiVersion = process.env.NEXT_PUBLIC_SANITY_API_VERSION ?? '2023-08-01';
// const token = process.env.NEXT_PUBLIC_SANITY_TOKEN ?? '';

export const sanityClient = createClient({
  projectId,
  dataset,
  apiVersion,
  token: '', // Currently not used sinde dataset is public
  useCdn: false, // Disable CDN to get fresh data on revalidation
} satisfies ClientConfig);
